
import axios from '@/axios-mock'
import browser from '@beastshop/browser'
import bridge from '@beastshop/bridge'
import querystring from 'query-string'
import track from '@/track'
import { getLink } from '@/components/app-menu/util'
import { getLinkPageData } from '@/link'

const STR_UNKNOWN_ERROR = "出错啦！"
const clientWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
const clientHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
const urlParams = querystring.parse(location.search.slice(1))
const shopId = urlParams.shopId
const app = browser.app()
const weixin = browser.weixin()

export function axiosAction ({url, method = 'GET', param = {}}, sdk) {
  let request = axios
  if (sdk) {
    request = sdk.request
  }

  return request({
    url: url,
    method: method,
    json: param
  })
  .then(({
    code,
    data
  }) => {
    return Promise.resolve(data)
  })
  .catch(err => {
    return Promise.reject(err)
  })
}

export function clone (data) {
  return JSON.parse(JSON.stringify(data))
}

export function getClientWidth () {
  return clientWidth
}

export function getClientHeight () {
  return clientHeight
}

const images = {
  bottom: "http://img.thebeastshop.com/app/config/bottom.png",
  soldOutNIcon: "http://img.thebeastshop.com/app/product/list/sold-out-new.png",
  offShelfNIcon: "http://img.thebeastshop.com/app/product/list/off-shelf-new.png",
  vipOnlyIcon: "http://img.thebeastshop.com/app/product/list/vip-only.png",
  store: {
    listTitle: {
      width: 650,
      height: 94,
      src: "http://img.thebeastshop.com/app/config/store-list-title.png"
    },
  },
  border: "http://img.thebeastshop.com/app/shop/border.png",
  categoryTitle: {
    // src: "http://img.thebeastshop.com/apppictures/2017-06-02/ce1e11fded22772862f4c7ab879068d9.png",
    src: "http://img.thebeastshop.com/app/shop/category.png",
    width: 368,
    height: 52
  },
  latestTitle: {
    src: "http://img.thebeastshop.com/app/shop/latest.png",
    width: 368,
    height: 52
  },
  recommendTitle: {
    src: "http://img.thebeastshop.com/app/shop/recommend.png",
    width: 368,
    height: 52
  },
  reviewAll: {
    src: "http://img.thebeastshop.com/app/shop/review-all.png",
    width: 252,
    height: 354
  },
  article: {
    border: "http://img.thebeastshop.com/app/config/article/border.png",
    lineIcon: "http://img.thebeastshop.com/app/config/article/line-icon.png",
  },
  defaultImage: "http://img.thebeastshop.com/images/mcatlog/banner/p.png",
  special: {
    newCoupon: {
      text: "http://img.thebeastshop.com/app/article/special/text.png",
      rule: "http://img.thebeastshop.com/app/article/special/rule.png",
      coupon: "http://img.thebeastshop.com/app/article/special/coupon.png?ver=1"
    },
    memberSystem: {
      sshy: "http://img.thebeastshop.com/app/article/special/sshy.png",
      xmhy: "http://img.thebeastshop.com/app/article/special/xmhy.png",
      lhhy: "http://img.thebeastshop.com/app/article/special/lhhy.png",
      dxhy: "http://img.thebeastshop.com/app/article/special/dxhy.png"
    }
  },
  lottery: {
    couponThird: "https://img.thebeastshop.com/app/article/lottery/coupon-third.png",
    coupon: "https://img.thebeastshop.com/app/article/lottery/coupon.png",
    point: "https://img.thebeastshop.com/app/article/lottery/point.png",
    free: "https://img.thebeastshop.com/app/article/lottery/free.png",
    none: "https://img.thebeastshop.com/app/article/lottery/none.png",
    couponXwz: "https://img.thebeastshop.com/app/article/lottery/coupon-xwz.png",
    noneXwz: "https://img.thebeastshop.com/app/article/lottery/none-xwz.png",
    bgXwz: "https://img.thebeastshop.com/app/article/lottery/bg-xwz3.png",
    normalProd: "https://img.thebeastshop.com/app/article/lottery/normal-prod.png",
  },
  bigSmallImage: {
    arrow:  "https://img.thebeastshop.com/app/article/big-small-image/arrow.png",
  }
}

// const MODULE_MAP = {
//   'image': '图片',
//   'new-image': '新图片',
//   'image-banner': '图片轮播',
//   'new-banner': '新轮播',
//   'image-index': '压字图片',
//   'video': '视频',
//   'text': '文本',
//   'nav': '导航',
//   'list': '商品列表',
//   'new-list': '新商品列表',
//   'ud-product': '上下单品',
//   'product': '左右单品',
//   'product-banner': '单品轮播',
//   'product-horizon': '多品滑动',
//   'rush-tab': '抢购Tab',
//   'program-tab': '小程序Tab',
//   'fix-tab': '可吸顶Tab',
//   'new': '新品',
//   'coupon': '优惠券',
//   'time': '倒计时',
//   'store': '门店',
//   'new-line': '分割线',
//   'special': '特殊模块',
//   'lottery': '抽奖模块',
//   'select-gift': '快速选礼',
//   'nofix-nav': '不吸顶导航',
//   'big-small-image': '大小图',
//   'coupon-code': '优惠吗兑换',
//   'new-time': '新倒计时',
//   'get-point': '领取积分',
//   'market-activity': '领营销奖励',
//   'benefit-code': '特权码兑换',
//   'voice-mod': '语音模块'
  
//   // 'lesson-base-info': '',
//   // 'lesson-link': '',
//   // 'lesson-text': '',
//   // 'line-title': '',
  
// }
const MODULE_MAP = {
  //图片/视频
  'image': '单图',
  'new-banner': '多图轮播',
  'new-image': '多图左右滑',
  'video': '视频',
  'buoy': '右下角浮标',

  //商品
  'new-list': '商品列表',
  'slide-product': '商品左右滑',
  'product': '左右单品',
  'ud-product': '上下单品',
  'new': '新鲜上架',
  'rush-tab': '抢购商品',

  //排版
  'nav': '导航',

  //营销
  'coupon': '领优惠券',
  'get-point': '领积分',
  'coupon-code': '优惠码兑换',
  'benefit-code': '特权码兑换',
  'lottery': '九宫格抽奖',
  'market-activity': '领营销奖励',
  'image-lottery': '图片抽奖',

  //其他
  'new-time': '倒计时',
  'select-gift': '快速选礼',
  'text': '文本',
  'voice': '语音',
  'new-line': '分割线',
  'special': '特殊模块',
  'paper': '壁纸下载',


  //废弃的老旧模块
  // 'image-banner': '图片轮播',
  // 'image-index': '压字图片',
  // 'list': '商品列表',
  // 'product-banner': '单品轮播',
  // 'product-horizon': '多品滑动',
  // 'program-tab': '小程序Tab',
  // 'fix-tab': '可吸顶Tab',
  // 'time': '倒计时',
  // 'store': '门店',
  // 'nofix-nav': '不吸顶导航',
  // 'big-small-image': '大小图',
  // 'voice-mod': '语音模块'
  
}

export function getImages () {
  return images
}

export function getUrlParams () {
  const search = location.search.slice(1)
  const urlParams = querystring.parse(search)
  return urlParams
}

export function checkAppType () {
  if(app) {
    return "app"
  } else if(weixin) {
    return "m"
  } else {
    return "none"
  }
}

export function isApp () {
  if(app) {
    return true
  } else {
    return false
  }
}

export function invalidP (p) {
  return !p || p.invisible
}

export function invalid (p) {
  return !p || p.invisible || p.offShelf
}

function createAjax (method, url) {
  let xhr = new XMLHttpRequest();
  if ('withCredentials' in xhr) {
    xhr.open(method, url, true);
  } else if (typeof XDomainRequest != 'undefined') {
    xhr = new XDomainRequest();
    xhr.open(method, url);
  } else {
    xhr = null;
  }
  return xhr;
}

export function scmAjax (method, url, callback) {
  let xhr = createAjax("get", url)
  if(xhr) {
    xhr.send()
    xhr.onload = () => {
      let responseText = xhr.responseText
      try {
        let json = JSON.parse(xhr.responseText)
        let responseCode = json.responseCode
        if (responseCode === "000000" ) {
          if(json.obj) {
            if(json.obj.code === "200") {
              callback(null, json.obj.data)
            } else {
              callback(json.obj.message?json.obj.message:STR_UNKNOWN_ERROR)
            }
          } else {
            callback(json.responseContent?json.responseContent:STR_UNKNOWN_ERROR)
          }
        } else {
          callback(json.responseContent?json.responseContent:STR_UNKNOWN_ERROR)
        }
      } catch(e) {
        callback(e)
      }
    };
  } else {
    callback(STR_UNKNOWN_ERROR)
  }
}

export function formatModules (modules, memberTags) {
  let newMods = []
  if(typeof modules === "string") {
    try {
      modules = JSON.parse(modules)
    } catch(e) {}
  }
  modules.forEach((m, index) => {
    if (typeof m.data === 'string') {
      try {
        m.data = JSON.parse(m.data)
      } catch(e) {}
    }
    if (m.type === "image" || m.type === "image-index") {
      if(m.data.image && m.data.image.src) {
        let curM = getModule(m, index)
        m.showFlag = curM.showFlag
        m.nav = curM.nav
      } else {
        m.showFlag = false
      }
    } else if (m.type === "video") {
      if(m.data.poster && m.data.poster.src && m.data.src) {
        let curM = getModule(m, index)
        m.showFlag = curM.showFlag
        m.nav = curM.nav
      } else {
        m.showFlag = false
      }
    } else if (m.type === "text-title" || m.type === "text-content") {
      if(m.data.text) {
        let curM = getModule(m, index)
        m.showFlag = curM.showFlag
        m.nav = curM.nav
      } else {
        m.showFlag = false
      }
    } else if (m.type === "product" || m.type === "ud-product") {
      if(m.data.id) {
        let curM = getModule(m, index)
        m.showFlag = curM.showFlag
        m.nav = curM.nav
      } else {
        m.showFlag = false
      }
    } else if (m.type === "image-banner" || m.type === "fix-tab" || m.type === "new-banner") {
      m.showFlag = false
      const items = m.data.items
      
      if(items && items.length > 0) {
        let newItems = []
        items.forEach((i, index) => {
          let image = i.image
          if(m.type === "new-banner") {
            image = i.media
          }
          if(image && image.src) {
            newItems.push(i)
          }
        })

        let memberItems = []
        if(memberTags && memberTags.length && (m.type === "image-banner" || m.type === "new-banner")) {//需要校验新老客
          newItems && newItems.forEach(item => {
            if(item.customer === 'ALL' || memberTags.indexOf(item.customer) !== -1 || (item.customer === 'DELINEATION' && memberTags.indexOf(item.customerCode) !== -1)) {
              memberItems.push(item)
            }
          })
        } else {
          memberItems = newItems
        }

        if(memberItems.length) {
          m.data.items = memberItems
          const curM = getModule(m, index)
          m.showFlag = curM.showFlag
          m.nav = curM.nav
        }
      }
    } else if (m.type === "product-banner") {
      if(m.data.ids && m.data.ids.length > 0) {
        let curM = getModule(m, index)
        m.showFlag = curM.showFlag
        m.nav = curM.nav
      } else {
        m.showFlag = false
      }
    } else if (m.type === "article") {
      if(m.data.type === "image") {
        if(m.data.image && m.data.image.src) {
          let curM = getModule(m, index)
          m.showFlag = curM.showFlag
          m.nav = curM.nav
        } else {
          m.showFlag = false
        }
      } else if(m.data.type === "video") {
        if(m.data.source) {
          let curM = getModule(m, index)
          m.showFlag = curM.showFlag
          m.nav = curM.nav
        } else {
          m.showFlag = false
        }
      } else {
        m.showFlag = false
      }
    } else if (m.type === "categories") {
      if(m.data.items && m.data.items.length > 0) {
        let curM = getModule(m, index)
        m.showFlag = curM.showFlag
        m.nav = curM.nav
      } else {
        m.showFlag = false
      }
    } else if (m.type === "list" || m.type === "shop-list" || m.type === "store-list" || m.type === "new-list") {
      if(m.data.ids && m.data.ids.length > 0) {
        let curM = getModule(m, index)
        m.showFlag = curM.showFlag
        m.nav = curM.nav
      } else {
        m.showFlag = false
      }
    } else if (m.type === "nav") {
      let curM = getModule(m, index)
      m.showFlag = curM.showFlag
      m.nav = curM.nav
    } else if (m.type === "rush-tab") {
      if(m.data.codes && m.data.codes.length > 0) {
        let curM = getModule(m, index)
        m.showFlag = curM.showFlag
        m.nav = curM.nav
      } else {
        m.showFlag = false
      }
    } else if (m.type === "store") {
      if((m.data.image && m.data.image.src) || m.data.storeId) {
        let curM = getModule(m, index)
        m.showFlag = curM.showFlag
        m.nav = curM.nav
      } else {
        m.showFlag = false
      }
    } else if (m.type === "product-horizon") {
      if(m.data.id || (m.data.ids && m.data.ids.length === 0)) {
        let curM = getModule(m, index)
        m.showFlag = curM.showFlag
        m.nav = curM.nav
      } else {
        m.showFlag = false
      }
    } else if (m.type === "new-image") {
      m.showFlag = false
      const items = m.data.items
      
      if(items && items.length > 0) {
        let newItems = []
        items.forEach((i, index) => {
          if(i.media && i.media.src) {
            newItems.push(i)
          }
        })
        
        if(memberTags && memberTags.length) {
          if((m.data.customer !== 'ALL' && m.data.customer !== 'DELINEATION' && memberTags.indexOf(m.data.customer) === -1) || (m.data.customer === 'DELINEATION' && memberTags.indexOf(m.data.customerCode) === -1)) {
            newItems = []
          }
        }
        
        if(newItems.length) {
          m.data.items = newItems
          const curM = getModule(m, index)
          m.showFlag = curM.showFlag
          m.nav = curM.nav
        }
      }
    } else if (m.type === "new-line") {
      if(m.data.lineHeight) {
        let curM = getModule(m, index)
        m.showFlag = curM.showFlag
        m.nav = curM.nav
      } else {
        m.showFlag = false
      }
    } else if (m.type === "special") {
      let curM = getModule(m, index)
      m.showFlag = curM.showFlag
      m.nav = curM.nav
    } else if (m.type === "lottery") {
      if(m.data.activityId) {
        let curM = getModule(m, index)
        m.showFlag = curM.showFlag
        m.nav = curM.nav
      } else {
        m.showFlag = false
      }
    } else if (m.type === "select-gift") {
      m.showFlag = false
      const items = m.data.items
      
      if(items && items.length > 0) {
        let newItems = []
        items.forEach((i) => {
          if(i.title) {
            newItems.push(i)
          }
        })

        if(newItems.length) {
          m.data.items = newItems
          const curM = getModule(m, index)
          m.showFlag = curM.showFlag
          m.nav = curM.nav
        }
      }
    } else if (m.type === "nofix-nav") {//不吸顶导航
      if(m.data.id) {
        let curM = getModule(m, index)
        m.showFlag = curM.showFlag
        m.nav = curM.nav
      } else {
        m.showFlag = false
      }
    } else if (m.type === "big-small-image") {
      m.showFlag = false
      const items = m.data.items
      
      if(items && items.length > 0) {
        let newItems = []
        items.forEach((i, index) => {
          if(i.bigImage && i.bigImage.src && i.smallImage && i.smallImage.src) {
            newItems.push(i)
          }
        })

        if(newItems.length) {
          m.data.items = newItems
          const curM = getModule(m, index)
          m.showFlag = curM.showFlag
          m.nav = curM.nav
        }
      }
    } else if (m.type === "coupon-code") {//优惠码兑换
      if(m.data.bgImage && m.data.bgImage.src) {
        let curM = getModule(m, index)
        m.showFlag = curM.showFlag
        m.nav = curM.nav
      } else {
        m.showFlag = false
      }
    } else if (m.type === "new-time") {//新倒计时
      if(m.data.bgImage && m.data.bgImage.src) {
        let curM = getModule(m, index)
        m.showFlag = curM.showFlag
        m.nav = curM.nav
      } else {
        m.showFlag = false
      }
    } else if (m.type === "market-activity") {//市场营销
      if(m.data.image && m.data.image.src) {
        if(!memberTags || !memberTags.length || !m.data.customerCode || memberTags.indexOf(m.data.customerCode) !== -1) {
          let curM = getModule(m, index)
          m.showFlag = curM.showFlag
          m.nav = curM.nav
        }
      } else {
        m.showFlag = false
      }
    } else if (m.type === "benefit-code" || m.type === "voice") {//特权码兑换模块  语音模块
      if(m.data.bgImage && m.data.bgImage.src) {
        let curM = getModule(m, index)
        m.showFlag = curM.showFlag
        m.nav = curM.nav
      } else {
        m.showFlag = false
      }
    } else if (m.type === "slide-product") {
      if(m.data.dataOriginType && m.data.dataOriginValue) {
        let curM = getModule(m, index)
        m.showFlag = curM.showFlag
        m.nav = curM.nav
      } else {
        m.showFlag = false
      }
    } else if (m.type === "buoy") {
      m.showFlag = false
      const {
        image,
        startTime,
        endTime
      } = m.data
      const curTime = new Date().getTime()
      
      if(image && image.src && curTime>=startTime && curTime<=endTime) {
        if(memberTags && memberTags.length) {
          if(m.data.customer === 'ALL' || memberTags.indexOf(m.data.customer) !== -1 || (m.data.customer === 'DELINEATION' && memberTags.indexOf(m.data.customerCode) !== -1)) {
            const curM = getModule(m, index)
            m.showFlag = curM.showFlag
            m.nav = curM.nav
          }
        } else {
          const curM = getModule(m, index)
          m.showFlag = curM.showFlag
          m.nav = curM.nav
        }
      }
    } 
    else {
      let curM = getModule(m, index)
      m.showFlag = curM.showFlag
      // m.showFlag = true
      if(curM.nav) {
        m.nav = curM.nav
      }
    }
    m.showFlag && newMods.push(m)
  })
  return newMods
}

function getModule (m, index) {
  if(m.type === 'paper') {
    return {
      showFlag: false
    }
  } else {
    let nav = null
    if(m.data.navName) {
      nav = {
        navName: m.data.navName,
        navIndex: index,
        curFlag: false
      }
    }
    return {
      showFlag: true,
      nav: nav
    }
  }
}

export function getCountDown (time) {
  if(!time) {
    return null
  }
  let endDate = new Date(time),
    _now = new Date()
  let leftTime = endDate.getTime() / 1000 - _now.getTime() / 1000,
    leftsecond = parseInt(leftTime),
    day1 = Math.floor(leftsecond / (60 * 60 * 24)),
    hour = Math.floor((leftsecond - day1 * 24 * 60 * 60) / 3600),
    minute = Math.floor((leftsecond - day1 * 24 * 60 * 60 - hour * 3600) / 60),
    second = Math.floor(leftsecond - day1 * 24 * 60 * 60 - hour * 3600 - minute * 60)
  // hour += day1 * 24
  return {
    day: day1,
    hour,
    minute,
    second
  }
}

export function login (sdk) {
  return new Promise((resolve, reject) => {
    console.log(sdk, 'login sdk')
    sdk.ensureLogged()
    .then(({ member }) => {
      switch (sdk.adapter.env) {
        case 'app':
          bridge.getMember()
          .then(member => {
            resolve(member)
          })
          .catch(err => {
            // pending = false
            reject(err)
          })
          break
        case 'miniprogram':
          sdk.getMember()
          .then(member => {
            resolve(member)
          })
          .catch(err => {
            // pending = false
            reject(err)
          })
          break
        default: 
          resolve(member)
      }
    })
    .catch((err) => {
      // pending = false
      reject(err)
    })
  })
}

export function colorToRgb(data, onlyColor) {
  let reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/
  let sColor = data.toLowerCase()
  if(sColor && reg.test(sColor)) {
    if(sColor.length === 4) {
      let sColorNew = "#"
      for(let i=1; i<4; i+=1) {
        sColorNew += sColor.slice(i,i+1).concat(sColor.slice(i,i+1))
      }
      sColor = sColorNew
    }
    //处理六位的颜色值
    let sColorChange = []
    for(let i=1; i<7; i+=2) {
      sColorChange.push(parseInt("0x"+sColor.slice(i,i+2)))
    }
    if(onlyColor) {
      return sColorChange
    } else {
      return "RGB(" + sColorChange.join(",") + ")"
    }
  } else {
    return sColor
  }
}

export function formatProgramLink (link) {
  if(!link) {
    return ''
  }

  const path = [
    "pages/index/index",
    "pages/category-v2/index",
    "pages/funny/index",
    "pages/store/index",
    "pages/my/member"
  ]

  let tabFlag = false
  path.some(p => {
    if(link.indexOf(p) !== -1) {//存在
      tabFlag = true
    }
  })

  return tabFlag
}

export function formatTrackDataModules (modules, pageType) {
  const indexTypes = ['image-banner', 'image-index', 'new', 'video', 'image', 'new-image', 'new-banner', 'new-line', 'new-list', 'new-time', 'buoy']
  let checkMods = []
  let newMods = []

  if(pageType === 'index') {
    modules.forEach(m => {
      if(indexTypes.indexOf(m.type) !== -1) {
        checkMods.push(m)
      }
    })
  } else {
    checkMods = modules
  }
  
  checkMods.forEach((m, index) => {
    const type = m.type
    const data = m.data
    let pageObj = null
    if(data.link) {
      pageObj = getLinkPageData({
        link: data.link
      })
    }
    // console.log(pageObj, 'pageObj')
    const trackData = {
      // operation_module: getModuleName(pageType, type),
      operation_module: MODULE_MAP[type],
      operation_module_number: type==='buoy'?-1:index-0+1,
      module_number: 1,
      operation_name: data.trackTitle || '',
      operation_type: data.trackServiceType || '',
      skip_page_type: pageObj?pageObj.skip_page_type:'',
      skip_page_name: pageObj?pageObj.skip_page_name:'',
      skip_page_id: pageObj?pageObj.skip_page_id:''
    }

    if(type === 'image-banners' || type === 'product-banners' || type === 'new-image' || type === 'new-banner') {
      // trackData.module_number = 1
      if(data.items && data.items[0]) {
        trackData.operation_name = data.items[0].trackTitle || ''
        trackData.operation_type = data.items[0].trackServiceType || ''
      }
    }
    m.data.trackData = trackData
    
    newMods.push(m)
  })
  return newMods
}

export function getModuleName (pageType, moduleType) {
  let pageName = ''
  if(pageType === 'index') {
    pageName = '首页'
  }
  if(pageType === 'article') {
    pageName = '专题页'
  }
  if(pageType === 'story') {
    pageName = '封面故事页'
  }

  let moduleName = ''
  Object.keys(MODULE_MAP).forEach(key => {
    if(key === moduleType) {
      moduleName = `${pageName}${MODULE_MAP[key]}`
    }
  })
  
  return moduleName
}

export function trackAction ({trackData, pageObj={}}) {
  const track_data = Object.assign(trackData, pageObj)
  sa.track('OperationClick', track_data)
}



// WEBPACK FOOTER //
// ./static/renderer-config/lib/util.js